import { ApiRequest } from "GlobalFunctions";
import { calculateTaxes } from "../../Orders/CalculateTaxes";
import { enqueueSnackbar, useSnackbar } from "notistack";
/*========================================================
GET TAXES
========================================================*/
export const getTaxesPercentage = async () => {
    
    const cart = JSON.parse(localStorage.getItem('cart') || '{}');

    await ApiRequest({
        url: '/taxes/getTaxes',
        method: 'POST',
        body: {
            cart
        },
        setResponse: (response: any) => {
            if (response.status === 'success') {
                const updatedCart = {
                    ...cart,
                    ...response
                };

                localStorage.setItem('cart', JSON.stringify(updatedCart));
                calculateTaxes(updatedCart);

            } else {
                enqueueSnackbar(response.message, { variant: 'error' });
                localStorage.setItem('tax_error', response.message || 'Error calculating taxes');
            }
        }
    });
}


